<ng-container *ngIf="landTitles.length">
  <div style="
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0px;
  ">
    <button
    class="default_secondary-btn "
    [useExistingCss]="true"
    printSectionId="print-section"
    ngxPrint>Print Report</button>

  </div>

<div id="print-section">
  <div style="background-color: rgb(254, 254, 254);">
    <div *ngIf="reportRef?.Logo" style="display: flex;
    margin: 0px 0px 25px 35px;
    align-items: center;
    flex-direction: row;
    gap: 20px;
    ">
      <img src="{{reportRef?.Logo}}" alt="Logo" width="50px" height="50px">
      <h3 class="company">{{ reportRef?.CompanyName}}</h3>
    </div>
    <table class="table table-hover" style="margin-top: 10px;">
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Group Name</th>
          <th scope="col">Sub Group Name</th>
          <th scope="col">Sub Sub Group Name</th>
          <th scope="col">Land Code</th>
          <th scope="col">Land Title-Name</th>
          <th scope="col">Acquisition Date</th>
          <th scope="col">Area of land</th>
          <th scope="col">UOM</th>
          <th scope="col">Acquisition Cost</th>
          <th scope="col">Address of Land</th>
          <th scope="col">Expiration Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody >
        <tr *ngFor="let landTitle of landTitles; index as i"
        (click)="onView(landTitle)"
        style="cursor: pointer;"
        >
          <th scope="row">{{i + 1}}</th>
          <td>{{getGroupName(landTitle?.GroupId)}}</td>
          <td>{{getSubGroupName(landTitle?.SubGroupId)}}</td>
          <td>{{getSubSubGroupName(landTitle?.SubSubGroupId)}}</td>
          <td>{{ landTitle.LandCode }}</td>
          <td>{{ landTitle.LandName }}</td>
          <td>{{ landTitle.AcquisitionDate | date }}</td>
          <td>{{ landTitle.TotalArea }}</td>
            <td>{{ getMeasureName(landTitle.MeasureId) }}</td>
          <td>
            <span class="sub_element" *ngIf="landTitle.TotalArea">{{
              getTotalCost(landTitle?.TotalCost)
                | currency:getCurrencyCode(landTitle.CurrencyId):'symbol-narrow'
            }}</span>

            <span class="sub_element" *ngIf="!landTitle.TotalArea">0</span>
          </td>
          <td>{{ landTitle?.AssetLocationAddress }}</td>
          <td>{{ landTitle?.ExpirationDate | date }}</td>
          <td>{{ getAcquisitionTypeName(landTitle.AcquisitionTypeId) }}</td>
        </tr>

      </tbody>
    </table>

  </div>
</div>
</ng-container>
